import { combineReducers } from 'redux';

// instructor reducers
import {
    instructorCoursesMapReducer as instructorCoursesMap,
    instructorImportCoursesListReducer as instructorImportCoursesList,
    instructorInstituteListReducer as instituteList,
    instructorDepartmentListReducer as departmentList

} from 'Reducers/Instructor/instructorCoursesListReducer';
import instructorCourseGC from 'Reducers/Instructor/instructorCourseGCReducer';
import instructorConceptDataMap from 'Reducers/Instructor/instructorConceptDataReducer'


// student reducers
import studentCoursesMap from 'Reducers/Student/studentCoursesListReducer';
import {
    publicCoursesReducer as publicCoursesMap,
    paginationInfoReducer as paginationInfo
}
    from 'Reducers/Common/publicCoursesReducer';
// import paginationInfoReducer from 'Reducers/Common/publicCoursesReducer'
import studentCourseGroupsMap from 'Reducers/Student/studentCourseGroupsReducer';
import studentGroupConceptsMap from 'Reducers/Student/studentGroupConceptsReducer';
import studentConceptDataMap from 'Reducers/Student/studentConceptDataReducer'



const rootReducer = combineReducers({

    instructorCoursesMap,
    instructorImportCoursesList,
    publicCoursesMap,
    instituteList,
    departmentList,
    paginationInfo,
    instructorCourseGC,
    instructorConceptDataMap,

    studentCoursesMap,
    studentCourseGroupsMap,
    studentGroupConceptsMap,
    studentConceptDataMap,
});

export default rootReducer;
